// Member profile filters options
import moment from 'moment-timezone';

import { dateFormat, serverDateFormat } from '../../../constants';

export const rejectReasonOptions = [{ value: '1', label: 'Record Already Exists in Perx' }];

type Options = Array<{ value: string; label: string }>;

export const residenceTypeOptions: Options = [
  { value: '1', label: 'Owned' },
  { value: '2', label: 'Rented' },
  { value: '3', label: 'Mortgaged' },
  { value: '4', label: 'Living with Relatives' }
];

export const civilStatusOptions: Options = [
  { value: '1', label: 'Single' },
  { value: '2', label: 'Married' },
  { value: '3', label: 'Separated' },
  { value: '4', label: 'Widowed' }
];

export const educationOptions: Options = [
  { value: '1', label: 'Elementary' },
  { value: '2', label: 'High School' },
  { value: '3', label: 'College' },
  { value: '4', label: 'Masteral' },
  { value: '5', label: 'Doctorate' },
  { value: '6', label: 'Vocational' }
];

export const incomeLevelOptions: Options = [
  { value: '01', label: '1 to 10000' },
  { value: '02', label: '10001 to 20000' },
  { value: '03', label: '20001 to 40000' },
  { value: '04', label: '40001 to 70000' },
  { value: '05', label: '70001 to 120000' },
  { value: '06', label: '120001 to 200000' },
  { value: '07', label: '200001 to 99999999' }
];

// Card filters options

export const cardStatusOptions = [
  { value: 'A', label: 'Active', color: 'green', actions: ['Block', 'Replace'] },
  { value: 'B', label: 'Blocked', color: 'red', actions: ['Replace'] },
  { value: 'F', label: 'For Activation', color: 'blue', actions: ['Activate', 'Block', 'Replace'] },
  { value: 'I', label: 'Inactive', color: 'gray', actions: ['Replace'] }
];

export const getCardStatus = (value: 'A' | 'B' | 'F' | 'I' | 'N') => {
  if (value === 'N') return { label: 'Not Specified', color: 'gray', actions: [] };
  return cardStatusOptions.find(option => option.value === value);
};

export interface CardType {
  value: '01' | '03' | '04';
  label: 'Emerald' | 'Sapphire' | 'Diamond';
}

export const cardTypeOptions: CardType[] = [
  { value: '01', label: 'Emerald' },
  { value: '03', label: 'Sapphire' },
  { value: '04', label: 'Diamond' }
];

export const getCardType = (value: CardType['value']) => {
  return cardTypeOptions.find(option => option.value === value);
};

export const applicationTypeOptions = [
  { value: '01', label: 'New' },
  { value: '03', label: 'Update Info' },
  { value: '06', label: 'Renewal' }
];

export const membershipTypeOptions = [
  { value: '01', label: 'Bank Customer' },
  { value: '02', label: 'Credit Card Customer' }
];

// Points filters options

export const transactionCodeOptions = [
  {
    value: 'MNLRDMP-99',
    description: 'Manual Redemption (Negative) tagged as adjustment in ORS2'
  },
  {
    value: 'RDMPCSA-99',
    description: 'Manual Redemption (Credit to CASA) (Negative) tagged as adjustment in ORS2'
  },
  {
    value: 'RDMPPRD-99',
    description: 'Manual Redemption – Promo Related (Negative) tagged as adjustment in ORS2'
  },
  {
    value: 'UPDTDBL-91',
    description:
      'Updated host balance (Positive) – campaign code that will be used for migration initial balance'
  },
  {
    value: 'UPDTDBL-99',
    description: 'Updated host balance (Negative) – campaign code that will be used for migration'
  },
  {
    value: 'RECNADJ-91',
    description: 'Positive Reconciliation Adjustment'
  },
  {
    value: 'RECNADJ-99',
    description: 'Negative Reconciliation Adjustment'
  },
  {
    value: 'BDOTRSF-91',
    description: 'BDO Points Transfer(Positive)'
  },
  {
    value: 'BDOTRSF-99',
    description: 'BDO Points Transfer(Negative)'
  },
  {
    value: 'MCGCOLL-91',
    description: 'Merged/Collapsed CIF(Positive)'
  },
  {
    value: 'MCGCOLL-99',
    description: 'Merged/Collapsed CIF(Negative)'
  },
  {
    value: 'MCGREIN-91',
    description: 'BDO Manually Reinstated Forfeited Points(Positive)'
  },
  {
    value: 'MCGREIN-99',
    description: 'BDO Manually Reinstated Forfeited Points, Reversal(Negative)'
  },
  {
    value: 'BDORFEE-91',
    description: 'Card Replacement Fee – Reversal (Positive)'
  },
  {
    value: 'BDORFEE-99',
    description: 'Card Replacement Fee (Negative)'
  },
  {
    value: 'BBGREGD-91',
    description: 'Regular Total Monthly Earned Points-Dollar(Positive)'
  },
  {
    value: 'BBGREGD-99',
    description: 'Regular Total Monthly Earned Points-Dollar(Negative)'
  },
  {
    value: 'BBGREGP-91',
    description: 'Regular Total Monthly Earned Points-Peso(Positive)'
  },
  {
    value: 'BBGREGP-99',
    description: 'Regular Total Monthly Earned Points-Peso(Negative)'
  },
  {
    value: 'CAT-BDORW1',
    description: 'BDO Credit Card push points to Primary(Positive)'
  },
  {
    value: 'CAT-BDORW2',
    description: 'BDO Credit Card push points to 3rd party(Positive)'
  },
  {
    value: 'GFTRDMP-99',
    description: 'Redemption thru GiftAway (Negative)'
  },
  {
    value: 'GFTRDMP-91',
    description: 'Redemption thru GiftAway – Reversal (Positive)'
  },
  {
    value: 'PAYRDMP-99',
    description: 'Redemption thru BDOPay (Negative)'
  },
  {
    value: 'PAYRDMP-91',
    description: 'Redemption thru BDOPay – Reversal (Positive)'
  },
  {
    value: 'POSRDMP-99',
    description: 'POS Redemption(Negative)'
  },
  {
    value: 'POSRDMP-91',
    description: 'POS Redemption – Reversal (Positive)'
  },
  {
    value: 'PRXTRSF-91',
    description: 'PRX Points Transfer (Positive)'
  },
  {
    value: 'PRXTRSF-99',
    description: 'PRX Points Transfer (Negative)'
  },
  {
    value: 'PXMRDMP-99',
    description: 'Perx Manual Redemption via dashboard (Negative)'
  },
  {
    value: 'PXMRDMP-91',
    description: 'Perx Manual Redemption via dashboard (Reversal)'
  },
  {
    value: 'TRTSRDM-99',
    description: 'BDO Treats Redemptions'
  },
  {
    value: 'MCGIN24-91',
    description: 'Forfeited Points of Card Inactive for 24mos,Reversal (Positive)'
  },
  {
    value: 'MCGIN24-99',
    description: 'Forfeited Points of Card Inactive for 24months (Negative)'
  },
  {
    value: 'MCI_EXP-91',
    description: 'Forfeiture of Expired Points, Reversal  (Positive)'
  },
  {
    value: 'MCI_EXP-99',
    description: 'Forfeiture of Expired Points (Negative)'
  },
  {
    value: 'BDOINCTR-1',
    description: 'BDO Manual Adjustment - Credit (incl in tiering) - Positive'
  },
  {
    value: 'BDOINCTR-9',
    description: 'BDO Manual Adjustment - Debit (incl in tiering) - Negative'
  },
  {
    value: 'BDOEXCTR-1',
    description: 'BDO Manual Adjustment - Credit (excl from tiering) - Positive'
  },
  {
    value: 'BDOEXCTR-9',
    description: 'BDO Manual Adjustment - Debit (excl from tiering) - Negative'
  },
  {
    value: 'MCGDECD-91',
    description: 'Deceased Clients - Credit - Positive'
  },
  {
    value: 'MCGDECD-99',
    description: 'Deceased Clients - Debit - Negative'
  },
  {
    value: 'BDOPHL01-1',
    description: 'Home Loan 10x Pts - Positive'
  },
  {
    value: 'BDOPHL01-9',
    description: 'Home Loan 10x Pts - Negative'
  },
  {
    value: 'BDOPHL02-1',
    description: '5x Pts Home Loan - Positive'
  },
  {
    value: 'BDOPHL02-9',
    description: '5x Pts Home Loan - Negative'
  },
  {
    value: 'BDOREGIN-1',
    description: 'BDO Manual Adj of RegTrans-Credit(incl in tiering) - Positive'
  },
  {
    value: 'BDOREGIN-9',
    description: 'BDO Manual Adj of RegTrans-Debit(incl in tiering) - Negative'
  },
  {
    value: 'CBGPKAHE-1',
    description: 'BDO Pay Kahera 200 Points Signup Acquisition Promo(Positive)'
  },
  {
    value: 'CBGPKAHE-9',
    description: 'BDO Pay Kahera 200 Points Signup Acquisition Promo(Negative)'
  },
  {
    value: 'BBGPHOLI-1',
    description: 'Holiday Million Rewards Raffle (Positive)'
  },
  {
    value: 'BBGPHOLI-9',
    description: 'Holiday Million Rewards Raffle (Negative)'
  },
  {
    value: 'TIGPDMMF-1',
    description: 'Rewards Points from Money Market Fund Investments (Positive)'
  },
  {
    value: 'TIGPDMMF-9',
    description: 'Rewards Points from Money Market Fund Investments (Negative)'
  },
  {
    value: 'BDOIRDMP-1',
    description: 'Redeem BDO Insure insurance with Rewards Points (Positive)'
  },
  {
    value: 'BDOIRDMP-9',
    description: 'Redeem BDO Insure insurance with Rewards Points (Negative)'
  },
  {
    value: 'CBGPPBBL-1',
    description: 'Q2 2026 Buy Load Pay Bills and get Rewards Points (Positive)'
  },
  {
    value: 'CBGPPBBL-9',
    description: 'Q2 2026 Buy Load Pay Bills and get Rewards Points (Negative)'
  }
];

export const productCodeOptions = [];

export const pointsBalanceOptions = [
  { value: '0-9999', label: '0.00-99.99' },
  { value: '10000-29999', label: '100.00-299.99' },
  { value: '30000-49999', label: '300.00-499.99' },
  { value: '50000-99999', label: '500.00-999.99' },
  { value: '100000-149999', label: '1,000.00-1,499.99' },
  { value: '150000-249999', label: '1,500.00-2,499.99' },
  { value: '250000-499999', label: '2,500.00-4,999.99' },
  { value: '500000-749999', label: '5,000.00-7,499.99' },
  { value: '750000-999999', label: '7,500.00-9,999.99' },
  { value: '1000000-1999999', label: '10,000.00-19,999.99' },
  { value: '2000000-4999999', label: '20,000.00-49,999.99' },
  { value: '5000000-99999999', label: '50,000.00 and above' }
];

export const errorCodeOptions = [
  {
    value: '1',
    label: 'Card Status is Inactive'
  },
  {
    value: '2',
    label: 'Duplicate Transaction Record Found'
  },
  {
    value: '3',
    label: 'Invalid Transaction Code'
  },
  {
    value: '4',
    label: 'Card Number not found'
  },
  {
    value: '5',
    label: 'Insufficient points'
  }
];

export const optionsMap = {
  reject_reason: rejectReasonOptions,
  residence_type: residenceTypeOptions,
  civil_status: civilStatusOptions,
  education: educationOptions,
  income_level: incomeLevelOptions,
  card_type: cardTypeOptions,
  application_type: applicationTypeOptions,
  membership_type: membershipTypeOptions,
  transaction_code: transactionCodeOptions,
  product_code: productCodeOptions,
  points_balance: pointsBalanceOptions,
  error_code: errorCodeOptions
};

const dateFilterKeys = [
  'date_of_birth',
  'expiry_date',
  'activation_date',
  'member_since',
  'block_date',
  'transaction_date'
];

export const renderFilterValue = (key, value) => {
  if (optionsMap[key]) {
    const selectedOption = optionsMap[key].find(option => option.value === value);
    return selectedOption?.label || selectedOption?.value;
  }

  if (dateFilterKeys.includes(key)) {
    return moment(value, serverDateFormat).format(dateFormat);
  }

  return value;
};

export const findOptionLabel = (options: Options, value: string) => {
  return options.find(option => option.value === value)?.label || null;
};
